import { useState } from 'react'
import { Header } from './Header'
import { ConsoleDrawer } from './ConsoleDrawer'
import { CalendarPanel } from '@/features/calendar/CalendarPanel'
import { PhotosPanel } from '@/features/photos/PhotosPanel'
import { UploadQueue } from '@/features/upload/UploadQueue'

export function MainLayout() {
  const [consoleOpen, setConsoleOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date())

  return (
    <div className="min-h-screen flex flex-col bg-zinc-950">
      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <div className="flex-1 flex overflow-hidden">
        {/* Calendar Panel - 25% width */}
        <div className="w-1/4 min-w-[280px] max-w-[360px] border-r border-zinc-800 p-4 overflow-auto">
          <CalendarPanel
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
          />
        </div>

        {/* Photos Panel - 75% width */}
        <div className="flex-1 p-4 overflow-auto">
          <PhotosPanel selectedDate={selectedDate} />
        </div>
      </div>

      {/* Upload Queue */}
      <UploadQueue />

      {/* Console Drawer */}
      <ConsoleDrawer open={consoleOpen} onOpenChange={setConsoleOpen} />
    </div>
  )
}
